const cyohProductData = {
  link: '/shop/create-your-own-hamper/create-your-own-hamper/',
  title: 'Create Your Own Hamper',
  name: 'Create Your Own Hamper',
  image: {
    sourceUrl:
      'https://cart.gourmetbasket.com.au/wp-content/uploads/2024/07/create-your-own-hamper.jpg',
    altText: 'Create Your Own Hamper',
    sizes: '',
    title: 'Create Your Own Hamper',
  },
  id: 206686,
};

export default cyohProductData;
